module.exports = __webpack_public_path__ + "static/decentraland-eba5cd2d289687fd8c857877041a0a53.jpg";